import FooterContact from './footer-contact';

export default FooterContact;